export const staticTextConsts = {
    GET_STATIC_TEXTS: "GET_STATIC_TEXTS",
    UPDATE_STATIC_TEXTS: "UPDATE_STATIC_TEXTS",
};